import React, { useState, useEffect } from 'react';
function ApprovalList({ response }) {
	const [approvers, setApprovers] = useState([]);

	useEffect(() => {
		if (response && response.REC) {
			setApprovers(response.REC);
		}
	}, [response]);

	return (
		<ol className="approval-process mb30">
		{approvers.map((approver, index) => (
			<li className="item" key={index}>
          		<div className="role">{approver["APPROVAL_ROLE_NM"]}</div>
          			<div className="do">
	            		{approver["LAST_SAN_YN"] === 'Y' && approver["REP_SAN_YN"] === 'N' && approver["SAN_STS"] === '1' &&
	            			<span style={{alignSelf:"baseline",marginLeft:"30px"}}>전결</span>
	            		}
	            		{approver["REP_SAN_YN"] === 'Y' && approver["SAN_STS"] === '1' &&
	            			<span style={{alignSelf:"baseline",marginLeft:"30px"}}>대결</span>
	            		}
						{approver["SAN_STS_NM"] !== '' && approver["FILE_ID_YN"] === 'Y' && approver["SAN_STS"] === '1' && (
							  <img width="44px" height="44px"
								src={'data:application/octet-stream;base64,' + approver["FILE_NM"]}
								alt={approver["SAN_STS_NM"]}
							  />
						)}
	            		{approver["SAN_STS_NM"] !== '' && approver["FILE_ID_YN"] === 'N' && approver["SAN_STS"] === '1' && 
	            			<p className="stamp">{approver["SAN_STS_NM"]}</p>
	            		}
    	        		{approver["SAN_STS_NM"] !== '' && approver["SAN_STS"] === '2' && <p className="stamp">{approver["SAN_STS_NM"]}</p>}
        			    {approver["SAN_DATETIME"] !== '' && <p className="date">{approver["SAN_DATETIME"]}</p>}
          			</div>
          		<div className="who" style={{whiteSpace:"nowrap",textAlign:"center",textAlignLast:"center"}}>{approver["PERSON_POSI_NM"]}<br/>
				  {(approver["REP_PERSON_POSI_NM"] != null && approver["REP_PERSON_POSI_NM"] !== '') && <>대결자 : {approver["REP_PERSON_POSI_NM"]} </>}
				</div>
        	</li>
      	))}
    	</ol>
	);
}

export default ApprovalList; 